import { Controller, FieldErrors } from "react-hook-form";
import CustomMultiSelect from "../../CustomMultiSelect";
import "./style.css";

interface IProps {
  name: string;
  control: any;
  options: { label: string; value: string }[];
  className?: string;
  containerClassName?: string;
  label: string;
  showClear?: boolean;
  showSearch?: boolean;
  error?: string | FieldErrors;
  disabled?: boolean;
  loading?: boolean;
  isRequired?: boolean;
}

const ControlledMultiSelect = ({
  name,
  control,
  options,
  className = "",
  containerClassName = "",
  label,
  showClear,
  showSearch,
  error,
  disabled,
  loading,
  isRequired,
}: IProps) => {
  const getErrorMessage = (): string | undefined => {
    if (!error) return undefined;

    if (typeof error === "string") {
      return error;
    }

    // Navega pela estrutura aninhada de erros usando o caminho do name
    // Ex: "address.street" -> error.address.street
    if (typeof error === "object") {
      const nameParts = name.split(".");
      let currentError: any = error;

      for (const part of nameParts) {
        if (currentError && typeof currentError === "object" && part in currentError) {
          currentError = currentError[part];
        } else {
          return undefined;
        }
      }

      return currentError?.message as string | undefined;
    }

    return undefined;
  };

  const errorMessage = getErrorMessage();

  return (
    <div className={`controlled-multiselect-container ${containerClassName || ""}`}>
      <label htmlFor={name} className={`controlled-multiselect-label ${errorMessage ? "error" : ""}`}>
        {label}
        {isRequired && <span className="input-text-required"> *</span>}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <CustomMultiSelect
            value={value || []}
            onChange={onChange}
            options={options}
            showClear={showClear}
            showSearch={showSearch}
            className={`controlled-multiselect-input ${className || ""} ${errorMessage ? "error" : ""}`}
            disabled={disabled || loading}
          />
        )}
      />
      {errorMessage && <small className="controlled-multiselect-error">{errorMessage}</small>}
    </div>
  );
};

export default ControlledMultiSelect;
